import { ViewModel,View, ObservableArray } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import  { DistrictManipulationView } from "./districtManipulation-view"
import { DistrictSelectorViewModel } from "./districtSelector";
import { getAsNumber } from "src/uicomponents/components/utilities";

export class DistrictManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت شعب';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.districts = ObservableArray.create<District>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new DistrictManipulationView();
    }
    public getTypeId(): string {
        return "VM-FFBDD5EA-5B81-423B-8ABE-60D6FD9347C5"
    }

    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set districts(v: ObservableArray<District>) { this._districts = v; } public get districts(): ObservableArray<District> { return this._districts;} private _districts: ObservableArray<District>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/GetAllDistricts',{
                FilteringInformation:filteringInformation
            });
            this.districts.update(...result.Districts.map(q=>{
                let r = new District(this);
                r.id = q.Id;
                r.name = q.Name;
                r.parentId = q.ParentId;
                r.parentName = q.ParentName;
                r.enabled = q.Enabled;
                r.brandTargets.update(...q.Targets.map(w=>{
                    let t = new singleBrandTarget(r);
                    t.id = w.Id;
                    t.brandId = w.CarBrandId;
                    t.brandCode = w.CarBrandCode;
                    t.brandName = w.CarBrandName;
                    t.targetAmount = w.Target;
                    t.baseBenefit = w.BaseBenefit;
                    t.targetBenefit = w.TargetBenefit;
                    return t;
                }))
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }

    async requestDistrictCreation(){
        let editor = new districtEditor(this,new InsertServerUpdater());
        let brands = await ServerConnection.callServer('/Complex/WarehouseServices/GetAllCarBrand',{});
        editor.brandTargets.update(...brands.CarBrand.map(x=>{
            let r = new singleBrandTarget(editor);
            r.brandId = x.Id;
            r.brandName = x.Name;
            r.brandCode = x.Code;
            return r;
        }))
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }

    async districtUpdater(district: District){
        let editor = new districtEditor(this,new UpdateServerUpdater());
        district.cloneTo(editor);
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async toggle(district:District){
        try {
            this.isLoading = true;
            if (district.enabled) {
                let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/DisableDistrict',{
                    DistrictId: district.id
                });
                if (result.IsSuccessful == false) {
                    throw "new Error";
                }
                await this.messageBoxConfirmSuccess('شعبه غیر فعال شد','عملیات موفق');
            } else {
                let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/EnableDistrict',{
                    DistrictId: district.id
                });
                if (result.IsSuccessful == false) {
                    throw "new Error";
                }
                await this.messageBoxConfirmSuccess('شعبه فعال شد','عملیات موفق');
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
            this.loader.refresh();
        }
    }

}
export class District extends ViewModel{
    
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:DistrictManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        this.brandTargets = ObservableArray.create<singleBrandTarget>();
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set parentId(v: string) { this._parentId = v; } public get parentId(): string { return this._parentId;} private _parentId: string;
    public set parentName(v: string) { this._parentName = v; } public get parentName(): string { return this._parentName;} private _parentName: string;
    public set saleTarget(v: number) { this._saleTarget = v; } public get saleTarget(): number { return this._saleTarget; } private _saleTarget: number;
    public set brandTargets(v: ObservableArray<singleBrandTarget>) { this._brandTargets = v; } public get brandTargets(): ObservableArray<singleBrandTarget> { return this._brandTargets;} private _brandTargets: ObservableArray<singleBrandTarget>;
    public set enabled(v: boolean) { this._enabled = v; } public get enabled(): boolean { return this._enabled;} private _enabled: boolean;
    
    private _typedParent:DistrictManipulationViewModel;
    
    cloneTo(district:District){
        district.id = this.id;
        district.name = this.name;
        district.saleTarget = this.saleTarget;
        district.brandTargets.update(...this.brandTargets.map(x=>{
            let r = new singleBrandTarget(district);
            r.id = x.id;
            r.brandId = x.brandId;
            r.brandName = x.brandName;
            r.brandCode = x.brandCode;
            r.targetAmount = x.targetAmount;
            r.baseBenefit = x.baseBenefit;
            r.targetBenefit = x.targetBenefit;
            return r;
        }))
        district.setParent(this.parentId,this.parentName);
    }
    
    setParent(parentId: string, parentName: string) {
        this.parentId = parentId;
        this.parentName = parentName;
    }
    getParentId() {
        return this.parentId;
    }
    
    async edit(){
        this._typedParent.districtUpdater(this);
    } 
    
    async toggle(){
        let result:string; 
        if(this.enabled == true) {
            result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','غیرفعال کردن شعبه');
        } else {
            result = await this.messageBoxWarningYesNo('آیا مطمئنید؟','فعال کردن شعبه');
        }
        if(result=='yes'){
            this._typedParent.toggle(this);
        }
    }    

}
export class singleBrandTarget extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set brandId(v: string) { this._brandId = v; } public get brandId(): string { return this._brandId;} private _brandId: string;
    public set brandName(v: string) { this._brandName = v; } public get brandName(): string { return this._brandName;} private _brandName: string;
    public set brandCode(v: string) { this._brandCode = v; } public get brandCode(): string { return this._brandCode;} private _brandCode: string;
    public set targetAmount(v: number) { this._targetAmount = getAsNumber(v); } public get targetAmount(): number { return this._targetAmount;} private _targetAmount: number;
    public set baseBenefit(v: number) { this._baseBenefit = getAsNumber(v); } public get baseBenefit(): number { return this._baseBenefit;} private _baseBenefit: number;
    public set targetBenefit(v: number) { this._targetBenefit = getAsNumber(v); } public get targetBenefit(): number { return this._targetBenefit;} private _targetBenefit: number;
    
}
interface IServerUpdater{
    execute(district:District):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'شعبه با موفقیت ثبت شد.';
    }
    async execute(district: District): Promise<void> {
        await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/CreateDistrict',{
            Name:district.name,
            ParentDistrict:district.getParentId(),
            SaleTarget : district.saleTarget  ?? 0,
            Targets : district.brandTargets.map(x=>{return {
                CarBrandId : x.brandId,
                Target : x.targetAmount ?? 0,
                BaseBenefit : x.baseBenefit ?? 0,
                TargetBenefit : x.targetBenefit ?? 0
            }})
        });
    }
}
class UpdateServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'شعبه با موفقیت به روز رسانی شد.';
    }
    async execute(district: District): Promise<void> {
        await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/UpdateDistrict',{
            Name:district.name,
            DistrictId:district.id,
            ParentDistrict:district.getParentId(),
            SaleTarget : district.saleTarget ?? 0,
            Targets : district.brandTargets.map(x=>{return {
                CarBrandId : x.brandId,
                Target : x.targetAmount ?? 0,
                BaseBenefit : x.baseBenefit ?? 0,
                TargetBenefit : x.targetBenefit ?? 0
            }})
        });
    }
}

export class districtEditor extends District implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:DistrictManipulationViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        this.districtSelector = new DistrictSelectorViewModel(this);
    }
    closePopup(resultCode: string = null) {
    }
    
    private _serverUpdater:IServerUpdater;
    public set districtSelector(v: DistrictSelectorViewModel) { this._districtSelector = v; } public get districtSelector(): DistrictSelectorViewModel { return this._districtSelector;} private _districtSelector: DistrictSelectorViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    setParent(parentId: string, parentName: string) {
        this.districtSelector.selectById(parentId);
    }


    clearParent(){
        this.districtSelector.selectedItem = null;
    }
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.name)){
            result.push('نام شعبه مشخص نشده است.')
        }
        return result;
    }

    getParentId() {
        return this.districtSelector.selectedItem?.id;
    }
    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت شعبه');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }
}